import React from 'react';
import { ReloadOutlined, ShareAltOutlined, BarChartOutlined } from '@ant-design/icons';
import { useReports } from '../context/ReportsContext';

export default function ReportsHeader({ onOpenShare }) {
    const { triggerRefresh } = useReports();

    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2">
            <div>
                <div className="flex items-center gap-2.5">
                    <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-[#003263] dark:text-[#a7c8ff] flex items-center justify-center font-bold">
                        <BarChartOutlined style={{ fontSize: 18 }} />
                    </div>
                    <h1 className="text-3xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline tracking-tight">
                        Reports &amp; Analytics
                    </h1>
                </div>
                <p className="text-[#424750] dark:text-slate-400 font-medium text-sm mt-1">
                    Operational performance, workload, attendance, and predictive forecasts.
                </p>
            </div>

            <div className="flex items-center gap-2.5">
                <button
                    type="button"
                    onClick={triggerRefresh}
                    className="px-3.5 py-2 rounded-xl text-xs font-bold border border-slate-200 dark:border-neutral-800 bg-white dark:bg-black text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-neutral-900 transition-all shadow-xs flex items-center gap-1.5 cursor-pointer"
                >
                    <ReloadOutlined style={{ fontSize: 13 }} />
                    <span>Refresh</span>
                </button>
                <button
                    type="button"
                    onClick={onOpenShare}
                    className="px-4 py-2 rounded-xl text-xs font-bold bg-[#003263] hover:bg-[#00264d] dark:bg-blue-600 dark:hover:bg-blue-700 text-white shadow-xs transition-all flex items-center gap-1.5 cursor-pointer"
                >
                    <ShareAltOutlined style={{ fontSize: 13 }} />
                    <span>Share Report</span>
                </button>
            </div>
        </div>
    );
}
